import { useEffect, useState } from "react";
import Modal from "./Modal";
import { Responsive, WidthProvider } from "react-grid-layout";
import { useFormContext } from "react-hook-form";
import ReactPlayer from "react-player";
const ResponsiveGridLayout = WidthProvider(Responsive);

const ReorderVideoModal = ({ setReorderVideoModal, acceptedVideoFiles }) => {
  const { setValue, watch } = useFormContext();
  const [layoutsVideo, setLayoutsVideo] = useState({
    lg: [],
    md: [],
    sm: [],
    xs: [],
    xxs: [],
  });
  const [rowHeight, setRowHeight] = useState(210);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const onLayoutChangeVideo = (layout) => {
    if (JSON.stringify(layout) !== JSON.stringify(layoutsVideo)) {
      setLayoutsVideo(layout);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const baseLayout = acceptedVideoFiles.map((file, index) => ({
      x: 0,
      y: index,
      w: 1,
      h: 1,
      i: index.toString(),
      src: file,
    }));
    setLayoutsVideo({
      lg: baseLayout,
      md: baseLayout,
      sm: baseLayout,
      xs: baseLayout,
      xxs: baseLayout,
    });
  }, [acceptedVideoFiles]);

  useEffect(() => {
    if (screenWidth < 420) {
      setRowHeight(200);
    } else if (screenWidth < 768) {
      setRowHeight(160);
    } else if (screenWidth < 996) {
      setRowHeight(160);
    } else if (screenWidth < 1200) {
      setRowHeight(160);
    }
  }, [screenWidth]);

  const handleVideoChange = () => {
    const videoOrderedIds = [...layoutsVideo]
      .sort((a, b) => a.y - b.y || a.x - b.x)
      .map((item) => {
        return {
          index: item.i,
          url: acceptedVideoFiles[item.i],
        };
      });

    const updatedVideoUrls = videoOrderedIds.map((id) => {
      return {
        index: id.index,
        url: id.url,
      };
    });

    if (JSON.stringify(updatedVideoUrls) !== JSON.stringify(watch("videos"))) {
      setValue("videos", updatedVideoUrls);
    }
    setReorderVideoModal(false);
  };

  return (
    <Modal
      handleClick={() => setReorderVideoModal(false)}
      title="Reorder Videos"
      closeName="Cancel"
      submitName="Save"
      removeButtons
    >
      <p className="text-sm px-5">
        Please drag and drop the below media items to rearrange them and please
        do not forget to hit the 'Save' button on the 'Create page' form to save
        this change.
      </p>
      <section className="p-5 sm:h-[calc(100vh-500px)] h-[calc(100vh-300px)] overflow-y-auto">
        <div style={{ width: "100%", height: "auto" }}>
          <ResponsiveGridLayout
            className="layout"
            layouts={layoutsVideo}
            onLayoutChange={onLayoutChangeVideo}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 420, xxs: 0 }}
            cols={{ lg: 3, md: 2, sm: 2, xs: 3, xxs: 1 }}
            rowHeight={rowHeight}
            isResizable={false}
            isDraggable={true}
            compactType="horizontal"
          >
            {acceptedVideoFiles.map((file, index) => {
              const cols = 3;
              const idx = index;
              const x = idx % cols;
              const y = Math.floor(idx / cols);

              const videoSrc =
                typeof file.url === "string"
                  ? file.url
                  : file instanceof File
                  ? URL.createObjectURL(file)
                  : typeof file.url.url === "string"
                  ? file.url.url
                  : file.url instanceof File
                  ? URL.createObjectURL(file.url)
                  : "";

              const videoName =
                typeof file.url === "string"
                  ? file.url.split("/").pop()
                  : file instanceof File
                  ? file.name
                  : typeof file.url.url === "string"
                  ? file.url.url.split("/").pop()
                  : file.url instanceof File
                  ? file.url.name
                  : "";

              return (
                <div
                  key={index}
                  className="relative w-[200px] h-auto"
                  data-grid={{
                    x,
                    y,
                    w: 1,
                    h: 1,
                    src: file,
                    i: index.toString(),
                  }}
                >
                  <div className="">
                    <ReactPlayer
                      config={{
                        youtube: {
                          playerVars: {
                            rel: 0,
                          },
                        },
                      }}
                      controls={true}
                      height="100%"
                      playing={false}
                      style={{ borderRadius: "18px" }}
                      url={videoSrc}
                      width="100%"
                    />
                  </div>
                  <div className="absolute bottom-0 left-0 right-0  bg-black bg-opacity-50 p-1">
                    <div className="flex justify-between items-center gap-2">
                      <p className="text-white text-xs  truncate">
                        {videoName}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </ResponsiveGridLayout>
        </div>
      </section>
      <div className="flex items-center gap-3 px-6 py-6">
        <button
          onClick={() => {
            setReorderVideoModal(false);
          }}
          type="button"
          className="justify-center w-full bg-red-500 hover:bg-red-600 text-sm sm:text-base text-white px-3 py-2 rounded border border-borderMuted flex focus:outline-none transition-all duration-500"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleVideoChange}
          className="focus:outline-none justify-center disabled:bg-gray-400 text-white text-sm sm:text-base bg-[#0082B2] hover:bg-[#006d95] rounded px-3 py-2  w-full transition duration-150 ease-in"
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default ReorderVideoModal;
